export default __webpack_public_path__ + "2190ea146cc696c3242529f62b3d687c.png";